"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import { FormattedTitle } from "~/components/job-page/ad/formatted-title-eon";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function HeaderImageEonSverige(t0) {
  const $ = _c(36);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job.content.headerImage) {
    t1 = <div className="relative aspect-video lg:aspect-auto"><CustomImage className="h-full max-h-[750px] object-cover object-left" height={1070} sizes="(max-width: 1024px) 100vw, 60vw" src={job.content.headerImage} width={2000} /></div>;
    $[0] = job.content.headerImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== job.data.title) {
    t2 = <div className="text-lg xl:text-xl"><h1 className="mb-6 font-headline text-4xl" data-source="job"><FormattedTitle input={job.data.title} /></h1></div>;
    $[2] = job.data.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CustomImage alt="" className="mr-3" height={34} src="images/icons/location-pin.svg" width={34} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = job.data.locations?.[0]?.city;
  let t5;
  if ($[5] !== t4) {
    t5 = <li className="flex w-full items-start">{t3}<span data-source="job">{t4}</span></li>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CustomImage alt="" className="mr-3" height={34} src="images/icons/clock.svg" width={34} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== job.data.employmentType || $[9] !== t) {
    t7 = combineEmploymentTypes(job.data.employmentType, t);
    $[8] = job.data.employmentType;
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <li className="flex w-full items-start">{t6}<span data-source="job">{t7}</span></li>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CustomImage alt="" className="mt-1 mr-3" height={34} src="images/icons/file_white.svg" width={34} />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== job.data.contract) {
    t10 = <li className="flex w-full items-start">{t9}<span data-source="job">{job.data.contract}</span></li>;
    $[14] = job.data.contract;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t5 || $[18] !== t8) {
    t11 = <ul className="flex flex-col gap-2 font-medium text-lg lg:mt-8 xl:text-2xl">{t5}{t8}{t10}</ul>;
    $[16] = t10;
    $[17] = t5;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== job) {
    t12 = job.data.applicationUrl.length > 2 && <ApplyButton className="mt-6 mr-3 rounded-[8px] font-bold text-base hover:bg-secondary hover:text-white md:w-auto" job={job} variant="ghost" />;
    $[20] = job;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== job) {
    t13 = job.data.applicationUrlDirect && <ApplyButton className="mt-6 mr-3 rounded-[8px] font-bold text-base hover:bg-secondary hover:text-white md:w-auto" direct={true} job={job} variant="ghost" />;
    $[22] = job;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <div className="inline-block print:hidden">{t12}{t13}</div>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t11 || $[28] !== t14) {
    t15 = <div>{t11}{t14}</div>;
    $[27] = t11;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15 || $[31] !== t2) {
    t16 = <div className="h-full px-6 py-10 lg:max-w-[680px] lg:justify-self-start lg:px-10"><div className="mb-4 flex h-full flex-col justify-between xl:justify-end xl:gap-10">{t2}{t15}</div></div>;
    $[30] = t15;
    $[31] = t2;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t1 || $[34] !== t16) {
    t17 = <section className="w-full bg-primary text-white lg:flex lg:justify-center print:hidden"><div className="grid w-full auto-cols-fr lg:grid-flow-col xl:auto-cols-[3fr_2fr]">{t1}{t16}</div></section>;
    $[33] = t1;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}